import { ConfigProvider } from "providers/ConfigProvider";
import { DetailProvider } from "providers/ContractIdProvider";
import { EmailProvider } from "providers/EmailProvider";
import { InitialLanguageProvider } from "providers/InitialLanguageProvider";
import { KeycloakProvider } from "providers/KeycloakProvider";
import { PersistedApolloProvider } from "providers/PersistedApolloProvider";
import { ServiceWorkerRegistrationProvider } from "providers/ServiceWorkerRegistrationProvider";
import "styles/fonts.css";
import { Bounce, toast } from "react-toastify";
import { Button } from "./components";
import { SendEmail } from "./components/Email/SendEmail";
import { LogoutCountdownDialog } from "./components/LogoutCountdownDialog/LogoutCountdownDialog";
import { Toastify } from "./components/toastify";
import { UserWithLinkedContactRoutes } from "./pages/routes";
import { DocProducerProvider } from "./providers/DocProducerProvider";

function App() {
  return (
    <InitialLanguageProvider>
      <ServiceWorkerRegistrationProvider>
        <ConfigProvider>
          <KeycloakProvider>
            <PersistedApolloProvider>
              <DocProducerProvider>
                <EmailProvider>
                  <DetailProvider>
                    <Toastify />
                    <LogoutCountdownDialog />
                    <UserWithLinkedContactRoutes />
                    <SendEmail variant="popup" />
                  </DetailProvider>
                </EmailProvider>
              </DocProducerProvider>
            </PersistedApolloProvider>
          </KeycloakProvider>
        </ConfigProvider>
      </ServiceWorkerRegistrationProvider>
    </InitialLanguageProvider>
  );
}

export default App;
